export enum ONBOARDING_STATUS {
  START = 0,
  SET_PROFILE = 1,
  END = 2,
}
